'use strict';

const BasePresenter = require('./base');

class BookPresenter extends BasePresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
  }

  toHash() {
    const isAvailable = this.model.get('isAvailable');
    const isSellable = this.model.get('isSellable');
    const isSoldOut = this.model.get('isSoldOut');
    const isDisabled = !this.model.isReadyToBook() || !isSellable;

    return { isAvailable, isSellable, isSoldOut, isDisabled };
  }
}

module.exports = BookPresenter;
